import store from '../store';

export default class GeoClient {
  bearerToken;

  geoBaseUrl;

  citiesCount;

  constructor(bearerToken) {
    this.bearerToken = bearerToken;
    this.geoBaseUrl = process.env.VUE_APP_GEO_URL;
  }

  generateDefaultHeaders() {
    return {
      Accept: 'application/json',
      Authorization: `Bearer ${this.bearerToken}`,
    };
  }

  fetchCountries() {
    const requestUrl = `${this.geoBaseUrl}/rest/1.0/countries`;
    fetch(requestUrl, {
      method: 'GET',
      headers: this.generateDefaultHeaders(),
    }).then((response) => {
      response.json().then((data) => {
        // eslint-disable-next-line
        const options = data.items.map((option) => ({ value: option.countryGeoId, name: option.name }));
        // XXX: Change the name of The Netherlands, so it's easier for the users. See CP #128345.
        const netherlands = options.find((option) => option.name === 'The Netherlands');
        netherlands.name = 'Netherlands';
        // Sort the options by name so the Netherlands is on the correct spot.
        store.dispatch('setCountryOptions', options.sort((a, b) => a.name.localeCompare(b.name)));
      });
    });
  }

  async fetchCities(cityGeoIds) {
    store.dispatch('resetCities');
    const requestUrl = `${this.geoBaseUrl}/rest/1.0/cities`;
    const limit = 100;
    const cityCount = await this.fetchCitiesCount(cityGeoIds);
    let geoIdsQuery = '';
    cityGeoIds.forEach((cityGeoId) => {
      geoIdsQuery += `&geoIds=${cityGeoId}`;
    });
    for (let offset = 0; offset < cityCount; offset += limit) {
      const queryString = `?limit=${limit}&offset=${offset}${geoIdsQuery}`;
      fetch(requestUrl + queryString, {
        method: 'GET',
        headers: this.generateDefaultHeaders(),
      }).then((response) => {
        response.json().then((data) => {
          store.dispatch('addCities', data.items);
        });
      });
    }
    store.dispatch('setLoading', false);
  }

  async fetchCitiesCount(cityGeoIds) {
    this.citiesCount = 0;
    const requestUrl = `${this.geoBaseUrl}/rest/1.0/cities/count`;
    let geoIdsQueryString = '?';
    cityGeoIds.forEach((cityGeoId) => {
      geoIdsQueryString += geoIdsQueryString === '?' ? `geoIds=${cityGeoId}` : `&geoIds=${cityGeoId}`;
    });
    const response = await fetch(requestUrl + geoIdsQueryString, {
      method: 'GET',
      headers: this.generateDefaultHeaders(),
    });
    const responseData = await response.json();
    return responseData.count;
  }
}
